import i18n from 'i18next';
import React from 'react';
import { Link, useLocation, useRouteMatch } from 'react-router-dom';
import PropTypes from 'prop-types';
import useStyles from './Breadcrumbs.styles';

const Breadcrumbs = ({ entityType }) => {
  const classes = useStyles();
  const location = useLocation();
  const { path } = useRouteMatch();

  const breadcrumbs = location.pathname
    .split('/')
    .splice(1)
    .filter((i) => i);

  const routes = breadcrumbs.reduce((accumulator, breadcrumb, index) => {
    const label = i18n.t([`${entityType}.breadcrumb.${breadcrumbs[index]}`, `${entityType}.breadcrumb.details`]);
    if (label) {
      accumulator.push({ path: [path].concat(breadcrumbs.slice(1, index + 1)).join('/'), label });
    }

    return accumulator;
  }, []);

  return (
    <div className={classes.root}>
      <div className={classes.itemContainer}>
        {routes.map((route, index) => {
          const isCurrentLocation = index === routes.length - 1;
          return (
            <Link key={route.path} className={isCurrentLocation ? classes.selectedLink : classes.link} to={route.path}>
              {route.label}
            </Link>
          );
        })}
      </div>
    </div>
  );
};

Breadcrumbs.propTypes = {
  entityType: PropTypes.string.isRequired,
};

export default Breadcrumbs;
